<template>
    <div>
<!--
        <div style="width: 50%;margin: 20px 0;">
            <span class="searchName" >产品名称:</span>
            <el-input
                    class="mr10"
                    placeholder="名称 搜索"
                    v-model="cpinput"
                    clearable>
            </el-input>
            <el-button type="primary" @click="searchData" style="margin-left: 30px" :class="baseerp+'btn'">搜索</el-button>
        </div>
-->
        <el-table
                size="mini"
                border
                ref="multipleTable"
                :data="detailsData"
                row-key="vc_unique"
                height="220"
                v-loading="loading"
                tooltip-effect="dark"
                :row-class-name="tableRowClassName"
                @selection-change="handleSelectionChange"
                style="width: 100%">
            <template slot="empty">
                <p>{{dataText}}</p>
            </template>
            <el-table-column
                    align="left"
                    type="selection"
                    :reserve-selection="true"
                    width="55">
            </el-table-column>
            <el-table-column
                    :label="$t('form_serial_number')"
                    align="left"
                    type="index"
                    width="55">
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_hqgsname"
                    :label="$t('form_goods_rights_company')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_no"
                    :label="$t('form_batch_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_unit"
                    :label="$t('form_metering')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="kysl"
                    :label="$t('form_available_quantity')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="f_num"
                    :label="$t('form_delivery_quantity')">
                <!--<template slot-scope="scope">
                    <el-input-number :controls="false" :precision="5" class="" size="mini" v-model="scope.row.f_num" @change="xhChange(scope.row,scope.$index)"></el-input-number>
                </template>-->
            </el-table-column>
        </el-table>
        <!--<div class="tbRight">
            <div class="paginationBox textRig" >
                <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="pageCurrentChange"
                        :current-page.sync="currentPage"
                        :total="tableTotal">
                </el-pagination>
            </div>
        </div>-->
        <div slot="footer" class="dialog-footer" style="text-align: center;margin-top: 20px">
            <el-button type="primary" @click="saveForm" :class="baseerp+'btn'" :disabled="disabled"  size="small">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "RenderDetails",
        props:{
            renderDetails:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                cpinput:"",
                multipleSelection:"",
                detailsData:[],
                /*currentPage:0,
                tableTotal:0,
                pageSize:1,
                pageCount:1,*/
                gsid:0,
                gsid_out:0,
                i_pzid:0,
                ckid:0,
                baseerp:"",
                mid:0,
                loading:true,
                disabled:false,
                dataText:this.$t('tips_data_loading_in_progress'),
                selected:[],

            }
        },
        mounted() {
            this.baseerp=baseerp;
            this.mid=this.renderDetails.i_mid;
            this.selected=this.renderDetails.selected;
            /*this.ckid=this.productDetails.i_ckid;
            this.gsid_out=this.productDetails.i_gsid_out;
             this.i_pzid=this.productDetails.i_pzid;*/
            // console.log(this.renderDetails,"mounted拿到左侧数据传参")
            //调弹出框列表
            this.getProductList();
        },
        methods: {

            //input输入
            xhChange(val,index){
                // console.log(val,index,"xh");
                if (this.detailsData[index].kysl<val.f_num){
                    this.$message.error(this.$t('promanagement_the_delivery_quantity_shall_not_exceed_the_available_quantity'))
                    this.detailsData[index].f_num=this.detailsData[index].kysl;
                }
                //this.tableData[index].f_syzx=this.$math.subtract(this.tableData[index].f_zx,this.tableData[index].f_innum);
                //this.tableId=Math.random();

            },

            //获取产成品列表(新增里面点击+)
            async getProductList(){
                let param={
                    i_mid:this.mid,
                    i_rwid:this.renderDetails.i_id,
                    i_gsid:this.renderDetails.i_gsid,
                    i_ckid:this.renderDetails.i_ckid,

                    /*page_size:this.pageSize,
                    page_count:10,*/

                };
                let res=await API.getProductList(param);
                if(res.code==1){
                    this.loading=false;
                    if (res.data.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }
                    this.detailsData=res.data;
                    if (this.selected){
                        if (this.detailsData.length>0&&this.selected.length>0) {
                            this.selected.forEach(row => {
                                this.$refs.multipleTable.toggleRowSelection(row);
                            });
                        }
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            /*searchData(){
                this.pageSize=1;
                this.currentPage=1;
                //调弹出框列表
            },*/


            cancel(){
                this.$emit('closePop');
            },

            //点击选择框拿到当前行数据
            handleSelectionChange:function(val) {
                this.multipleSelection = val;
                // console.log(val,"aaaaaaaaaaaaaaa")
            },

            //公司id不同设置灰色
            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },

            saveForm(){
                this.disabled=true;
                this.$emit('transValue',this.multipleSelection);
                this.$emit('closePop');
            },

            pageCurrentChange(val){
                this.detailsData=[];
                /*this.pageSize=val;
                this.currentPage=val;*/
                this.getProductList();
            },
        },
    }
</script>

<style lang="scss" scoped>

    body {
        margin: 0;
    }

    .searchName{
        width: 100px; display: inline-block;vertical-align: middle;text-align: center;
    }
    .mr10{
        width: 50%;
    }

    /deep/{
        .danger-row{
            color: #999;
        }
    }


</style>